import React, { useEffect } from 'react'
import { Box, Choice, Paragraph } from '../../styles.style'
import { MuvicardService } from '../../../../services/muvicard.service'

const ExpirationDate = ({
	nextStep,
	choosen,
	setChoosen,
	setPaymentDay,
	hideLoading
}) => {
	useEffect(() => {
		hideLoading()
		MuvicardService.proposalStepRegister('Dia do vencimento', 'Acesso')
	}, [])

	const options = [10, 25]

	function selectItem(index, el) {
		setChoosen(index)
		setPaymentDay(el)
	}

	return (
		<Box>
			<div className="field">
				<Choice>
					<div className="box-choice">
						<Paragraph>
							Seu cartão foi aprovado! <br />
							Escolha o dia de vencimento para sua fatura!
						</Paragraph>
					</div>

					<div className="box-choice">
						{options.map((elemento, index) => {
							return (
								<div
									key={elemento}
									className={`choices ${
										choosen == index ? 'on' : 'off'
										}`}
									onClick={() => selectItem(index, elemento)}>
									<em>{elemento}</em>
								</div>
							)
						})}
					</div>
				</Choice>
			</div>
			<button
				disabled={choosen === null}
				className="button"
				type="button"
				onClick={() => nextStep()}>
				Prosseguir
			</button>
		</Box>
	)
}

export default ExpirationDate
